import { ComoAttachUserResponse } from '@core/models/como.model';
import { MarketplaceService } from '@core/services/marketplace/marketplace.service';
import { ComoService } from '@core/services/como/como.service';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ComoPluginType } from '@core/models/plugin.model';
import { AnalyticsService } from '@core/services/app/analytics.service';
import { ComoRegistrationNextStep } from '@core/services/como/como-link-registration.util';

export function routeComoRegistrationAfterAttach(
  response: ComoAttachUserResponse,
  deps: {
    comoService: ComoService;
    authStoreSelector: AuthStoreSelector;
    marketplaceSelector: MarketplaceStoreSelector;
    marketplaceService: MarketplaceService;
    analyticsService: AnalyticsService;
    source: 'phone' | 'otp';
  },
): ComoRegistrationNextStep {
  const marketplaceId = deps.marketplaceSelector.selectMarketplaceId();
  const comoPlugin = deps.marketplaceService.getPluginByType('como') as ComoPluginType | undefined;
  const allowAnonymousUser = !!comoPlugin?.allow_anonymous_user;
  const user = deps.authStoreSelector.selectUser();
  const decision = deps.comoService.resolveRegistrationStepAfterAttach(
    response,
    user,
    marketplaceId,
    allowAnonymousUser,
  );

  deps.analyticsService.log({
    level: decision.nextStep === 'complete' ? 'info' : 'warn',
    label: '[DOOD-3204] ComoRegistrationModal.afterAttach',
    message: {
      source: deps.source,
      next_step: decision.nextStep,
      reason: decision.reason,
    },
  });

  return decision.nextStep;
}
